<template>
  <div class="popin" :class="{'is-active': isActive }">
    <div class="popin-container">
      <button type="button" @click="onClose" class="popin-close">
        <i class="ic ic-close"></i>
      </button>
      <div class="popin-content" v-if="datas && datas.step0">
        <p class="project-current-step" v-html="Translator('soprasolar.project.save_popin.step', {type: Translator('soprasolar.project.step0.form.type.' + datas.step0.type)})"></p>
        <p class="project-title">{{ Translator('soprasolar.project.save_popin.title') }}</p>
        <p class="project-description" v-html="Translator('soprasolar.project.save_popin.content', {email: datas.step1.email})"></p>

        <button @click="onClick" class="button" :disabled="isLoading">
          {{ Translator('soprasolar.project.save_popin.button') }}
          <i class="ic ic-save" v-if="!isLoading"></i>
          <span class="button-loader" v-if="isLoading"></span>
        </button>
      </div>
    </div>
  </div>
</template>
<style scoped lang="scss">
  @import "~@/soprasolar-project/assets/styles/import";
  @import "~@/soprasolar-project/assets/styles/popin";
  .project-description {
    margin-bottom: rem(30);
  }
  .popin-content {
    padding: rem(30) rem(40) rem(40);
  }
</style>
<style lang="scss">
  body.is-popin-open {
    .viewer-element .header {
      z-index: 1;
    }
  }
</style>
<script>
import { gsap } from 'gsap/all';
import AppControlService from '@/soprasolar-project/services/AppControl';

export default {
  name: 'save-popin',
  components: {},
  data () {
    return {
      isActive: false,
      isLoading: false,
      datas: AppControlService.datas
    }
  },

  created() {
    AppControlService.on('datas', this._onUpdateDatas);
  },

  beforeDestroy() {
    AppControlService.off('datas', this._onUpdateDatas);
    document.body.classList.remove('is-popin-open');
  },

  mounted() {
    document.body.classList.add('is-popin-open');
    gsap.to(window, { duration: .3, scrollTo: 0, onComplete: () => {
      this.isActive = true;
    } });
  },

  methods: {
    onClick() {
      this.isLoading = true;
      AppControlService.save().then(() => {
        this.isLoading = false;
        AppControlService.popinSaveToggle(false);
      })
    },

    onClose() {
      AppControlService.popinSaveToggle(false);
    },

    Translator(key, datas = null) {
      return window.Translator.trans(key, datas);
    },

    _onUpdateDatas(datas) {
      this.datas = datas;
    }
  }
}
</script>